'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reducer = require('shared/modules/Matcher/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = require('shared/modules/JobMatch/reducer');

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = require('shared/modules/JobNextSteps/reducer');

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = require('shared/modules/JobCareerMap/reducer');

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = require('shared/components/HighlightedJobs/reducer');

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = require('shared/components/List/reducer');

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = require('shared/components/ListNoPagination/reducer');

var _reducer14 = _interopRequireDefault(_reducer13);

var _reducer15 = require('shared/components/PageFooter/reducer');

var _reducer16 = _interopRequireDefault(_reducer15);

var _reducer17 = require('shared/components/KeepInMind/reducer');

var _reducer18 = _interopRequireDefault(_reducer17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  matcher: _reducer2.default,
  jobMatch: _reducer4.default,
  highlightedJobs: _reducer10.default,
  list: _reducer12.default,
  listNoPagination: _reducer14.default,
  pageFooter: _reducer16.default,
  keepInMind: _reducer18.default,
  jobNextSteps: _reducer6.default,
  jobCareerMap: _reducer8.default
});

// ui reducers

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/ui/index.js
// module id = 1293
// module chunks = 0